// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Components
import { ConfirmDialogComponent, ConfirmDialogModel } from '../dialogs/confirm-dialog/confirm-dialog.component';

// Models
import { AppCleanup } from '../models';

@Injectable()
export class DialogService extends AppCleanup implements OnInit, OnDestroy {
	constructor(private dialog: MatDialog) {
		super();
	}

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	confirmAction(confirmModel: ConfirmDialogModel) {
		return this.dialog.open(ConfirmDialogComponent, {
			data: confirmModel,
			width: '100%',
			maxWidth: '450px',
			autoFocus: false,
		});
	}
}
